export default "<p>registration works!</p>\r\n"